<template>
  <button class="button">
    <span v-if="direction === 'right'">
      <i class="fas fa-arrow-right"></i>
    </span>
    <span v-else>
      <i class="fas fa-arrow-left"></i>
    </span>
  </button>
</template>

<style scoped>
.button {
  background-color: #6bb53b;

  width: 60px;
  height: 60px;

  padding: 8px;
  margin-bottom: 4px;

  border-radius: 10px;
  border: 0;
  color: white;
  font-weight: 700;
  font-size: 1.2em;
  cursor: pointer;
}
</style>

<script>
export default {
  props: {
    direction: {
      type: String,
      default: "right"
    }
  }
};
</script>
